import React from 'react';

function EmployeeModal({ employee, onClose, onEdit, onVacation, onDismiss, canEdit }) {
  if (!employee) return null;

  const getGenderName = (g) =>
    g === 'м' ? 'Мужской' : g === 'ж' ? 'Женский' : '—';

  const formatDate = (d) => {
    if (!d) return '—';
    return new Date(d).toLocaleDateString('ru-RU');
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h2>
            {employee.gender === 'м' ? '👨' : employee.gender === 'ж' ? '👩' : ''}{' '}
            {employee.full_name}
          </h2>
          <button className="modal-close" onClick={onClose}>
            ×
          </button>
        </div>

        <div className="modal-body">
          <div className="view-row">
            <div className="view-label">Табельный</div>
            <div className="view-value">{employee.tab_number || '—'}</div>
          </div>
          <div className="view-row">
            <div className="view-label">Телефон</div>
            <div className="view-value">{employee.phone || '—'}</div>
          </div>
          <div className="view-row">
            <div className="view-label">Дата рождения</div>
            <div className="view-value">
              {formatDate(employee.birth_date)}
              {employee.age ? ` (${employee.age} лет)` : ''}
            </div>
          </div>
          <div className="view-row">
            <div className="view-label">Пол</div>
            <div className="view-value">{getGenderName(employee.gender)}</div>
          </div>
          <div className="view-row">
            <div className="view-label">Вахта</div>
            <div className="view-value">{employee.is_vakhta ? 'Да' : 'Нет'}</div>
          </div>
          <div className="view-row">
            <div className="view-label">Выходной</div>
            <div className="view-value">{employee.day_off || '—'}</div>
          </div>

          {/* ===== РАССТАНОВКА ===== */}
          <div className="view-section">
            <div className="view-section-title">Расстановка</div>
            <div className="view-row">
              <div className="view-label">Цех</div>
              <div className="view-value">{employee.workshop_name || '—'}</div>
            </div>
            <div className="view-row">
              <div className="view-label">Зона</div>
              <div className="view-value">{employee.zone_name || '—'}</div>
            </div>
            <div className="view-row">
              <div className="view-label">Участок</div>
              <div className="view-value">{employee.section_name || '—'}</div>
            </div>
            <div className="view-row">
              <div className="view-label">Должность</div>
              <div className="view-value">{employee.role_name || '—'}</div>
            </div>
          </div>

          {(employee.vacation_start || employee.comment) && (
            <div className="view-section">
              <div className="view-section-title">Дополнительно</div>
              {employee.vacation_start && (
                <div className="view-row">
                  <div className="view-label">Отпуск</div>
                  <div className="view-value">
                    с {formatDate(employee.vacation_start)} по{' '}
                    {formatDate(employee.vacation_end)}
                  </div>
                </div>
              )}
              {employee.comment && (
                <div className="view-row">
                  <div className="view-label">Комментарий</div>
                  <div className="view-value">{employee.comment}</div>
                </div>
              )}
            </div>
          )}
        </div>

        <div className="modal-footer">
          {canEdit && (
            <>
              <button
                className="btn-vacation-modal"
                onClick={() => onVacation(employee)}
              >
                🏖 Отпуск
              </button>
              <button
                className="btn-dismiss-modal"
                onClick={() => onDismiss(employee)}
              >
                ❌ Уволить
              </button>
            </>
          )}
          <div className="modal-footer-right">
            {canEdit && (
              <button
                className="btn-save"
                onClick={() => onEdit(employee)}
              >
                ✏️ Редактировать
              </button>
            )}
            <button className="btn-cancel" onClick={onClose}>
              Закрыть
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default EmployeeModal;